import React from 'react'
import { ScrollView } from 'react-native'

type Props = React.ComponentProps<typeof ScrollView>

const scrollViewProps: Props = {
  horizontal: true,
  showsHorizontalScrollIndicator: false,
}

const TableScrollContainer: React.FC<Props> = ({ children, ...otherProps }) => (
  <ScrollView {...scrollViewProps} {...otherProps}>
    {children}
  </ScrollView>
)

export default TableScrollContainer
